module.exports = __webpack_public_path__ + "static/media/bulk_master_customer.8e825682.csv";